import coreCMS from 'assets/core/js/entry/cms'
import lastSeen from 'assets/core/js/module/lastSeen'
import dataLayer from 'assets/core/js/page/search/dataLayer'
import productFavorite from 'assets/core/js/page/search/product/favorite'
import faqToggle from 'assets/themes/vacances-campings/js/module/faqToggle'
import searchForm from 'assets/themes/vacances-campings/js/module/searchForm'
import budgetSlider from 'assets/themes/vacances-campings/js/page/search/budgetSlider'
import filters from 'assets/themes/vacances-campings/js/page/search/filters'
import imagesSliders from 'assets/themes/vacances-campings/js/page/search/imagesSliders'
import loading from 'assets/themes/vacances-campings/js/page/search/loading'
import map from 'assets/themes/vacances-campings/js/page/search/map'
import openProductPageLinks from 'assets/themes/vacances-campings/js/page/search/openProductPageLinks'
import sorting from 'assets/themes/vacances-campings/js/page/search/sorting'

document.addEventListener('DOMContentLoaded', function () {
  faqToggle()
  dataLayer()
  imagesSliders.init()
  budgetSlider()
  openProductPageLinks()
  sorting()
  loading()
  filters()
  map()
  productFavorite()

  searchForm()

  coreCMS()
  lastSeen()
})
